<div class="toolkit__libraryFilterBar">
	<button
		type="button"
		class="toolkit__filterChip"
		[ngClass]="{'toolkit__filterChip--active': (vm.libraryThemeFilter || 'all') === 'all'}"
		(click)="vm.libraryThemeFilter='all'; vm.applyLibraryFilters()">
		{{ 'Toolkit.Common.All' | translate }}
	</button>
	<button
		type="button"
		class="toolkit__filterChip"
		*ngFor="let t of vm.themes"
		[ngClass]="{'toolkit__filterChip--active': vm.libraryThemeFilter === t.id}"
		(click)="vm.libraryThemeFilter=t.id; vm.applyLibraryFilters()">
		{{ vm.themeName(t.id) | translate }}
	</button>
</div>

<div class="toolkit__libraryFilterBar toolkit__libraryFilterBar--secondary">
	<button
		type="button"
		class="toolkit__filterChip"
		[ngClass]="{'toolkit__filterChip--active': (vm.libraryFormatFilter || 'all') === 'all'}"
		(click)="vm.libraryFormatFilter='all'; vm.applyLibraryFilters()">
		{{ 'Toolkit.Common.All' | translate }}
	</button>
	<button
		type="button"
		class="toolkit__filterChip"
		[ngClass]="{'toolkit__filterChip--active': vm.libraryFormatFilter === 'psychoeducation'}"
		(click)="vm.libraryFormatFilter='psychoeducation'; vm.applyLibraryFilters()">
		{{ 'Toolkit.Format.Psychoeducation' | translate }}
	</button>
	<button
		type="button"
		class="toolkit__filterChip"
		[ngClass]="{'toolkit__filterChip--active': vm.libraryFormatFilter === 'exercise'}"
		(click)="vm.libraryFormatFilter='exercise'; vm.applyLibraryFilters()">
		{{ 'Toolkit.Format.Exercise' | translate }}
	</button>
	<button
		type="button"
		class="toolkit__filterChip"
		[ngClass]="{'toolkit__filterChip--active': vm.libraryFormatFilter === 'worksheet'}"
		(click)="vm.libraryFormatFilter='worksheet'; vm.applyLibraryFilters()">
		{{ 'Toolkit.Format.Worksheet' | translate }}
	</button>
	<button
		type="button"
		class="toolkit__filterChip"
		[ngClass]="{'toolkit__filterChip--active': vm.libraryFormatFilter === 'check-in'}"
		(click)="vm.libraryFormatFilter='check-in'; vm.applyLibraryFilters()">
		{{ 'Toolkit.Format.CheckIn' | translate }}
	</button>
	<button
		type="button"
		class="toolkit__filterChip"
		[ngClass]="{'toolkit__filterChip--active': vm.libraryFormatFilter === 'planner'}"
		(click)="vm.libraryFormatFilter='planner'; vm.applyLibraryFilters()">
		{{ 'Toolkit.Format.Planner' | translate }}
	</button>
</div>

	<div class="toolkit__libraryGrid" *ngIf="vm.filteredLibraryItems?.length">
		<div class="card toolkit__resourceCard" *ngFor="let item of vm.filteredLibraryItems">
			<div class="toolkit__resourceCardHeader">
				<div class="toolkit__resourceIcon" [ngClass]="'toolkit__resourceIcon--' + (item.format || item.type || 'other')">
					<span [innerHTML]="toolkit__resourceIcon(item.format || item.type)"></span>
				</div>
	            <span class="badge" [ngClass]="{'badge-green': item.difficulty === 'easy', 'badge-amber': item.difficulty !== 'easy'}">
					<ng-container [ngSwitch]="item.difficulty">
						<span *ngSwitchCase="'easy'">{{ 'Toolkit.Difficulty.Easy' | translate }}</span>
						<span *ngSwitchCase="'medium'">{{ 'Toolkit.Difficulty.Medium' | translate }}</span>
						<span *ngSwitchCase="'hard'">{{ 'Toolkit.Difficulty.Hard' | translate }}</span>
						<span *ngSwitchDefault>{{ item.difficulty }}</span>
					</ng-container>
				</span>
			</div>
			<div class="toolkit__resourceTitle">{{ item.title || item.name || item.id || ('Toolkit.Common.Untitled' | translate) }}</div>
			<div class="toolkit__resourceSummary">{{ item.summary || item.description || '' }}</div>
			<div class="toolkit__resourceMeta">
				<span class="toolkit__resourceMetaItem">{{ vm.themeIcon(item.theme || item.themeId) }} {{ vm.themeName(item.theme || item.themeId) | translate }}</span>
				<span class="toolkit__resourceMetaItem" *ngIf="item.duration">{{ item.duration }} {{ 'Toolkit.Common.Minutes' | translate }}</span>
				<span class="toolkit__resourceMetaItem" *ngIf="item.format || item.type">{{ vm.resourceFormatLabel(item.format || item.type) | translate }}</span>
			</div>
			<div class="toolkit__resourceActions">
				<button class="toolkit__btn toolkit__btn--primary" type="button" (click)="vm.assignItem(item)">{{ 'Toolkit.Common.Assign' | translate }}</button>
				<button class="toolkit__btn toolkit__btn--ghost" type="button" (click)="vm.previewItem(item)">{{ 'Toolkit.Common.Preview' | translate }}</button>
			</div>
		</div>
	</div>

<div class="toolkit__emptyPane" *ngIf="!vm.filteredLibraryItems?.length">
	<div class="toolkit__emptyTitle">{{ 'Toolkit.Placeholder.Title' | translate }}</div>
	<div class="toolkit__emptyText">{{ 'Toolkit.Library.Empty' | translate }}</div>
</div>
